import { SearchBar } from "Components/General/SearchBar";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";
interface ViewFilterSearchBarProps {
  onSearch: () => Promise<void>;
  onChange: (x: string) => void;
  value?: string;
}

export const ViewFilterSearchBar = ({ onSearch, onChange }: ViewFilterSearchBarProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  return (
    <>
      <SearchBar
        onSearch={onSearch}
        placeholder={t("Search in name and description")}
        queries={false}
        hideClear={false}
        style={{ marginBottom: 0 }}
        searchIconTooltip={t("Filter")}
        defaultValue={null}
        onChange={onChange}
      />
    </>
  );
};
